import AuthModel from "../../models/Auth";
import { ApiClient } from "../../utils/ApiClient";

/**
 * **Auth Endpoints**
 */
export default class Auth {
    /** @hidden */
    protected client: ApiClient;

    /**@hidden */
    constructor() {
        this.client = new ApiClient("/auth");
    }

    public async register(
        body: object,
        params: object = {}
    ): Promise<AuthModel> {
        return await this.client.post("/register", body, params);
    }

    public async login(body: object, params: object = {}): Promise<AuthModel> {
        return await this.client.post("/login", body, params);
    }
}
